define([
	'internal_util/Util',
	'internal_util/UiUtil',
	
	'amdi18n-loader?!state/nls/BindingState_strings',
	
	'view/UIView',
	'lib/jquery'
], function (
	Util,
	UiUtil,
	
	Strings,
	
	UIView,
	jQuery
) {
	'use strict';

	/**
	 * TextView class
	 */
	return function ConfirmationView() {
		var _view = jQuery(
				'<div class="skIdS_text-container">' +
//					'<p>' +Strings.second_device+ '<br/><span id="skIdS_text_remoteAddr"></span></p>' +
					'<p id="skIdS_text_information">' + '</p>' +
					'<span id="skIdS_text_visualConfimation" style="font-size:3em; font-weight: bold;"></span>' +
					'<br/>' +
					'<button id="skIdS_confirm-button" type="button" class="btn btn-default skIdS_identity-button">' +Strings.confirm+ '</button>' +
				'</div>'
				);

		UIView.call(this);

		_view.find('#skIdS_confirm-button').hide();
                _view.find('#skIdS_text_information').text(Strings.please_compare);

		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function () {
			// nothing to do
		};

		this.setRemoteAddr = function (addr) {
//			_view.find('#skIdS_text_remoteAddr')
//				.text(addr);
		};
                
                this.setInfoText = function (text) {
                    _view.find('#skIdS_text_information').text(text);
                };

		this.setVisualConfimation = function (code, callback) {
			_view.find('#skIdS_text_visualConfimation')
				.text(code);
			var t = document.getElementById("skIdS_modal-body");
			if (typeof  t.scrollTo === 'function') {
			    t.scrollTo(0,1000);
			}
			if (callback) {
				_view.find('#skIdS_confirm-button').show();
				_view.find('#skIdS_confirm-button').on('click', callback);
			}
		};

	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/bindings/ConfirmationView.js
// module id = 173
// module chunks = 1